// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZzTf","placeholdersHeader":"styles_placeholdersHeader__OJwBl","editorStyle":"styles_editorStyle__h_dnx","placeholdersBox":"styles_placeholdersBox__2d8JI"};